import _EnhastedTable from "./components/EnhastedTable";
import { TRow, TColumn, TCellData } from "./types";


export const GipnoTable = _EnhastedTable;
export type TRowType<T> = TRow<T>
export type TColumnType = TColumn;
export type TCellDataType<T> = TCellData<T>